import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiTagModule } from 'omnium-ui/tag';
import { ViewerLiability } from '../../../../../../core/models/api.models';
import {
  formatCurrency,
  formatDate,
  formatHolderLabel,
  formatLiabilityHolderShares,
  formatNumber,
  formatPercentage,
  formatText,
  parseAdditionalFields
} from '../../investor-viewer-format.utils';
import { InvestorViewerAccordionComponent } from '../investor-viewer-accordion/investor-viewer-accordion.component';

@Component({
  selector: 'dbw-investor-viewer-liabilities-section',
  imports: [OuiTagModule, InvestorViewerAccordionComponent],
  templateUrl: './investor-viewer-liabilities-section.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../investor-viewer-section.shared.scss'
})
export class InvestorViewerLiabilitiesSectionComponent {
  readonly liabilities = input.required<ViewerLiability[]>();

  protected readonly formatText = formatText;
  protected readonly formatDate = formatDate;
  protected readonly formatCurrency = formatCurrency;
  protected readonly formatNumber = formatNumber;
  protected readonly formatPercentage = formatPercentage;
  protected readonly formatHolderLabel = formatHolderLabel;
  protected readonly formatLiabilityHolderShares = formatLiabilityHolderShares;
  protected readonly parseAdditionalFields = parseAdditionalFields;
}
